import { css } from '@emotion/css';

import {
  Colors,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const stackClassName = css({
  marginBottom: Spacing['2XL'],
});

export const minimalClassName = css({
  borderBottom: `1px solid ${Colors.LightGray}`,
  paddingBottom: Spacing.XL,
  marginBottom: Spacing.XL,
  [SMALL_DEVICE_MQ]: {
    borderBottom: 'none',
    paddingBottom: 0,
    marginBottom: Spacing.LG,
  },
});
